import { h } from 'hyperapp'; // eslint-disable-line no-unused-vars
import './index.scss';

const MAX_INPUT_DIGITS_LENGTH = 2;
const DEFAULT_PLACEHOLDER = '';
const ENTER_KEY_SCAN_CODE = 13;

/**
 * Global mutable map used to store input field data
 * with last correct data from the last render.
 * Each input has three fields:
 * @field {string} storedValue
 * @field {number} selectionStart
 * @field {number} selectionEnd
 */
const inputsMap = new Map();

export const ApcInput = ({
    defaultValue = '',
    maxlength = MAX_INPUT_DIGITS_LENGTH,
    placeholder = DEFAULT_PLACEHOLDER,
    onBlur,
    onInput,
    disabled = 'false',
    className,
    beforeSubmitInput = () => {},
    uniqueId = Math.random(),
}) => {
    const handleInput = event => {
        const { value } = event.target;
        // If value is valid set its correct values into mutable map
        if (value === '' || /^\d+$/.test(value)) {
            inputsMap.set(uniqueId, {
                selectionStart: event.target.selectionStart,
                selectionEnd: event.target.selectionEnd,
                storedValue: value,
            });
        } else {
            // Restore last correct values with the cursor position
            const { storedValue, selectionEnd, selectionStart } = inputsMap.get(uniqueId);
            // eslint-disable-next-line
            event.target.value = storedValue;
            if (selectionEnd !== null && selectionStart !== null) {
                event.target.setSelectionRange(selectionStart, selectionEnd);
            }
        }

        return onInput(event);
    };
    const handleEnterKey = event => {
        if (ENTER_KEY_SCAN_CODE === event.keyCode) {
            beforeSubmitInput(event.target.value);
        }
        return false;
    };
    return (
        <div
            oncreate={() => {
                inputsMap.set(uniqueId, {
                    selectionStart: defaultValue.length - 1,
                    selectionEnd: defaultValue.length - 1,
                    storedValue: defaultValue,
                });
            }}
            class={`apcInputContainer apcInputContainer_size_small ${className} ${
                disabled ? 'apcInputContainer__disabled' : ''
            }`}
        >
            <input
                type="tel"
                value={defaultValue}
                maxlength={maxlength}
                placeholder={placeholder}
                class="apc-input"
                onblur={onBlur}
                oninput={onInput}
                tabindex="0"
                pattern="[0-9]*"
                inputmode="numeric"
                size="2"
                onkeydown={handleEnterKey}
                oninput={handleInput}
            />
        </div>
    );
};
